import { FileTypeExtensions } from 'service/file/types';
import { FilesContext } from 'types/types';
import { createAction } from 'typesafe-actions';
import { RBFile } from './types';

export const doFilesLoad = createAction('doFilesLoad')<{
  context: FilesContext;
  files: RBFile[];
}>();

export const doFilesDeleteFile = createAction('doFilesDeleteFile')<{
  fileId: string;
}>();

export const doFilePreview = createAction('doFilePreview')<{
  fileId: string;
  typeId: FileTypeExtensions;
  context: FilesContext;
}>();

export const doImagePreview = createAction('doImagePreview')<{
  fileId: string;
  context: FilesContext;
}>();

export const doFileDownload = createAction('doFileDownload')<{
  fileId: string;
  typeId: FileTypeExtensions;
  context: FilesContext;
}>();
